import { findDifferences } from "../utils/dataUtils";

export class NewRequestModal {
  constructor(selector) {
    this.jform = $(selector);
    this.form = document.querySelector(selector);
    this.fieldset = this.form.querySelector('fieldset');
    this.initializeEvents();
    this._input = null;
    this._dynamicRow = null;
    this._detailInput = null;
    this._statusInput = null;
    this._activeFiled = null;
    this._inputEdit = {
      target: null,
      caretPosition: null
    };
    this._save = debounce((data) => this._saveHandeler(data), 3000);
    this._inpitFileDocuments = null;
    this._inpitFilePhotos = null;
    this._saveTmp = true;

    this._modalData = getDataAll(this.fieldset);
  }

  _saveHandeler(data) {
    if (this.form.closest('.show'))
      sendData(data, window.Redirect.route('saveTmpRequest')).then((response) => {
        // console.log(response);
      });
  }

  initializeEvents() {
    this.jform.on('keyup', 'input[type="text"]', (event) => this._saveEditInput(event));
    this.jform.on('focus', 'input[type="text"]', (event) => this._saveFocusInput(event));
    this.jform.on('click', '*:not(input[type="text"])', (event) => this._unSaveFocusInput(event));
    this.form.addEventListener('fieldsetUpdated', (event) => this._saveTempData(event));
    this.jform.on('click', '.remove-row', this.removeRow.bind(this));
    this.form.addEventListener('click', () => (this._inpitEdit = false));
    this.jform.on('input', 'input', () => (this._inpitEdit = true));
    this.jform.on('input', '.name-input', debounce((event) => this.renderElement(event), 600));
    this.jform.on(
      'fieldsetUpdated',
      '.dynamic-row',
      debounce((event) => this.fileUdated(event), 0)
    );
    this.jform.on('click', '.button-link', (event) => this.processAddLink(event));

  }

  _saveEditInput(event) {
    this._inputEdit.target = event.target;
    this._inputEdit.caretPosition = event.target.selectionStart;
  }

  _saveFocusInput(event) {
    requestAnimationFrame(() => {
      // ожидает установку каретки браузером, т.к. это событие прохоидт после клика (фокуса) по элементу
      this._inputEdit.target = event.target;
      this._inputEdit.caretPosition = event.target.selectionStart;
    });
  }

  _unSaveFocusInput(event) {
    if (event.target.closest('input[type="text"]')) return;
    this._inputEdit.target = null;
    this._inputEdit.caretPosition = null;
  }

  _saveTempData(event) {
    if (event.detail.fieldset !== this.fieldset) {
      return;
    } else {
      // delete event.detail.data._FILES;  // т.к. файлы всё равно не сохраняются временно, удаляем
      this._save(event.detail.data);
    }
  }

  _getDataRow(target) {
    this._dynamicRow = target.closest('.dynamic-row');
    // window.fieldsetTracker.updateAllFieldsets(this._dynamicRow);
    const rowData = getDataAll(this._dynamicRow);
    const id = Object.keys(rowData.requestData)[0];
    return Object.assign(rowData, rowData.requestData[id], { id: id });
  }

  removeRow(event) {
    $(event.currentTarget).closest('.dynamic-row').remove();
    this.updateInputNames();
  }

  processAddLink(event) {
    const currentData = this._getDataRow(event.target);
    const promptText = currentData.link ? 'Ссылка указана: ' + currentData.link : 'Укажите ссылку';
    const data = prompt(promptText);

    if (data === null) {
      this.renderElement(event, { link: '' });
      return;
    }
    if (data.trim() === '') {
      return;
    }

    // Валидация ссылки (URL), допускает http и https
    const urlPattern = /^https?:\/\/[\w\-]+(\.[\w\-]+)+([\/\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
    if (!urlPattern.test(data.trim())) {
      alert('Пожалуйста, введите корректную ссылку (начинающуюся с http:// или https://).');
      return;
    }

    // дописываем данные в скрытый инпут
    event.target.closest('div').querySelector('input').value = data;
    event.target.closest('fieldset').updateData();
    this.renderElement(event, { link: data });
  }

  fileUdated(e) {
    const event = e.originalEvent.detail;

    if (
      typeof event.diff._FILES !== 'undefined' &&
      Object.values(findDifferences(this._modalData ?? {}, getDataAll(this.fieldset), true)).length
    ) {
      this.renderElement(event, event.data);
    }
  }

  renderElement(event, newData = {}) {
    this._dynamicRow = event.target.closest('.dynamic-row');
    const target = event.target;
    const data = Object.assign(this._getDataRow(event.target), newData);
    const trueInput = target.matches(`input[name="requestData[${data.id}][name]"]`); // проверяем, тот ли это input, при заполнении которого должна отрисоваться новая строка

    sendData(data, window.Redirect.route('getRequestRow')).then((response) => {
      this.processApiResponse(response.answer, data.place, trueInput); // Передаем имя активного элемента и позицию каретки
    });
  }

  processApiResponse(response, place, trueInput) {
    // Создаем временный элемент для парсинга HTML-строки в DOM-элемент
    this._inpitFileDocuments = this._dynamicRow.querySelector('.documents-input');
    this._inpitFilePhotos = this._dynamicRow.querySelector('.photos-input');

    insertHtmlWithScripts({
      html: response,
      parent: this._dynamicRow.querySelector('.control_panel_request_row'),
      selector: '.control_panel_request_row', replaceParent: true
    });

    this._dynamicRow.querySelector('.documents-input').replaceWith(this._inpitFileDocuments);
    this._dynamicRow.querySelector('.photos-input').replaceWith(this._inpitFilePhotos);

    this.updateInputNames();
    // Найти новый элемент по имени

    // Проверка на последний dynamicRow
    const allDynamicRows = this.form.querySelectorAll('.dynamic-row');
    const lastDynamicRow = allDynamicRows[allDynamicRows.length - 1];

    if (this._dynamicRow === lastDynamicRow && trueInput) {
      this.addNewRow();
    }

    this._modalData = getDataAll(this.fieldset);
  }

  addNewRow() {
    const allDynamicRows = this.form.querySelectorAll('.dynamic-row');
    const lastDynamicRow = allDynamicRows[allDynamicRows.length - 1];

    // Получаем шаблон и клонируем его содержимое
    const template = this.form.querySelector('template');
    const newRow = document.importNode(template.content, true);

    // Вставляем новый элемент после последнего динамического ряда
    lastDynamicRow.after(newRow);
    this.updateInputNames();
  }

  updateInputNames() {
    this.jform.find('.dynamic-row').each((index, element) => {
      $(element)
        .find('input, select')
        .each(function () {
          const nameTemplate = $(this)
            .attr('name')
            .replace(/\[\d+\]/, `[${index}]`);
          $(this).attr('name', nameTemplate);
        });
    });
  }
}
